<template>
  <div class="products-command-rail">
    <div class="products-command-rail__actions">
      <v-btn
        rounded
        class="i-btn-block-secondary products-command-rail__button"
        :loading="loading"
        v-tooltip="tooltip('manually create one product.')"
        @click="$emit('add-product')"
      >
        Add Product
      </v-btn>

      <v-btn
        v-if="showImageUpload"
        rounded
        class="i-btn-block-primary products-command-rail__button"
        :disabled="loading || imageUploadDisabled"
        @click="$emit('upload-images')"
        >Upload images</v-btn
      >

      <template v-if="showImportActions">
        <v-btn
          rounded
          class="i-btn-block-primary products-command-rail__button"
          :to="{ name: 'products-import' }"
          v-tooltip="tooltip('add many products using an Excel file.')"
        >
          Import Products
        </v-btn>

        <v-btn
          rounded
          class="i-btn-block-primary products-command-rail__button"
          :to="{ name: 'products-price-update' }"
          v-tooltip="
            tooltip(
              'update prices for many existing products using an Excel file.'
            )
          "
        >
          Update Prices
        </v-btn>
      </template>
    </div>

    <div class="products-command-rail__search-actions">
      <v-text-field
        dense
        hide-details
        outlined
        rounded
        clearable
        append-icon="mdi-magnify"
        background-color="#F0F0F0"
        class="products-command-rail__search"
        label="Search by Item Code, Brand, Product Description, or Unit Size"
        :model-value="search"
        @update:model-value="$emit('update:search', $event || '')"
      />

      <i-table-refresh-button :loading="loading" @refresh="$emit('refresh')" />
    </div>

    <v-autocomplete
      dense
      hide-details
      outlined
      clearable
      chips
      small-chips
      multiple
      label="Filter by brand"
      class="products-command-rail__filter"
      :items="brands"
      :model-value="selectedBrands"
      @update:model-value="$emit('update:selected-brands', $event || [])"
    />

    <v-autocomplete
      dense
      hide-details
      outlined
      clearable
      chips
      small-chips
      multiple
      label="Filter by category"
      class="products-command-rail__filter"
      :items="categories"
      :model-value="selectedCategories"
      @update:model-value="$emit('update:selected-categories', $event || [])"
    />
  </div>
</template>

<script>
import iTableRefreshButton from '@/modules/dataMaintenance/components/TableRefreshButton'

export default {
  components: {
    iTableRefreshButton
  },

  emits: [
    'add-product',
    'upload-images',
    'refresh',
    'update:search',
    'update:selected-brands',
    'update:selected-categories'
  ],

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    imageUploadDisabled: {
      type: Boolean,
      default: false
    },
    showImageUpload: {
      type: Boolean,
      default: false
    },
    showImportActions: {
      type: Boolean,
      default: false
    },
    search: {
      type: String,
      default: ''
    },
    brands: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    selectedBrands: {
      type: Array,
      default: () => []
    },
    selectedCategories: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    tooltip(content) {
      return {
        content,
        visible: this.$vuetifyDisplay.mdAndDown ? false : undefined
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.products-command-rail {
  display: grid;
  grid-template-columns: auto minmax(322px, 1fr) minmax(180px, 220px) minmax(
      180px,
      220px
    );
  gap: 12px;
  align-items: center;
  padding: 18px;
  border-bottom: 1px solid #dde1e8;
}

.products-command-rail__actions {
  display: flex;
  gap: 12px;
  white-space: nowrap;
}

.products-command-rail__search-actions {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 42px;
  gap: 10px;
  align-items: stretch;
}

:deep(.products-command-rail__button.v-btn) {
  min-height: 43px;
  padding: 0 18px;
  border-radius: 5px !important;
  box-shadow: none;
  font-size: 14px;
}

:deep(.products-command-rail__search .v-field) {
  border-radius: 22px;
}

:deep(.products-command-rail__filter .v-field) {
  border-radius: 5px;
}

@media (max-width: 1400px) {
  .products-command-rail {
    grid-template-columns: 1fr 1fr;
  }

  .products-command-rail__actions,
  .products-command-rail > :nth-child(2) {
    grid-column: span 2;
  }
}
</style>
